import type { WeekPill } from "@/features/certifications/participant-detail/types";

export const WEEK_PILLS = {
  COMPLETE: "complete",
  CURRENT: "current",
  FUTURE: "future",
} as const satisfies Record<string, WeekPill>;
